<div class="bgColorWhite body-scroll">
  @if (showData) {
<div class="text-center boldText"><h3>{{pageTitle}}</h3></div>
}
  @if (loading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}
  @if (!loading && recapAcctsData.length) {
<div class="col-md-12 boldText" style="width:100%;">
    <table class="table nowrap table-bordered table-condensed table-hover table-striped boldText custom-table">
      <thead><tr>@for (columnName of columnNames; track $index) {
<th nowrap>{{columnName}}</th>
}</tr></thead>
      <tbody>
      @for (recapAcctRow of recapAcctsData; track $index) {
<tr>
        @for (columnName of columnNames; track $index) {
<td nowrap [ngClass]="(columnName.toUpperCase() !== 'HOME OFFICE LEID' && columnName.toUpperCase() !== 'HOME OFFICE TAX CODE'
            && columnName.toUpperCase() !== 'FUNCTIONAL CURRENCY' && columnName.toUpperCase() !== 'ENTITY NAME'
            && columnName.toUpperCase() !== 'COUNTRY DESCRIPTION') ? 'rightAlign' : ''">
          {{(columnName.toUpperCase() !== 'HOME OFFICE LEID' && columnName.toUpperCase() !== 'HOME OFFICE TAX CODE'
            && columnName.toUpperCase() !== 'FUNCTIONAL CURRENCY' && columnName.toUpperCase() !== 'ENTITY NAME'
            && columnName.toUpperCase() !== 'COUNTRY DESCRIPTION') ? (recapAcctRow[columnName] | number) : recapAcctRow[columnName]}}
        </td>
}
      </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
